module.exports = __webpack_public_path__ + "img/bezier2.ce7ad39d.svg";